import type { SVGProps } from 'react';

export default function Tax(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3 17.2505H6.75C5.64543 17.2505 4.75 16.355 4.75 15.2505V8.75046C4.75 7.64589 5.64543 6.75046 6.75 6.75046H10.275M13.8 6.75046H17.25C18.3546 6.75046 19.25 7.64589 19.25 8.75046V11.3V15.2505C19.25 16.355 18.3546 17.2505 17.25 17.2505H13.8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7V4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M12 11.3333V8.33334"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M12 15.6667V12.6667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M12 20V17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M10.9989 10.0648C10.1369 10.2867 9.50009 11.0692 9.50009 12.0005C9.50009 12.9317 10.1369 13.7142 10.9989 13.9362V10.0648Z"
        fill="currentColor"
      />
      <path
        d="M12.9986 13.9361C13.8605 13.7141 14.4973 12.9317 14.4973 12.0005C14.4973 11.0692 13.8605 10.2868 12.9986 10.0648V13.9361Z"
        fill="currentColor"
      />
    </svg>
  );
}
